/**
 * Motion tokens — durations + easings for consistent animation across the web stack.
 * Per spec §3 (animation tokens), values are in ms; easings use cubic-bezier.
 */

export const durations = {
  instant: 0,
  micro: 150,
  short: 250,
  medium: 350,
  long: 450,
} as const;

export const easings = {
  /** General-purpose curve, slight ease at both ends. */
  standard: 'cubic-bezier(0.2, 0, 0, 1)',
  /** Element entering view — ease-out feel. */
  decelerate: 'cubic-bezier(0, 0, 0.2, 1)',
  /** Element leaving view — ease-in feel. */
  accelerate: 'cubic-bezier(0.4, 0, 1, 1)',
  /** Spring-style overshoot for playful interactions. */
  spring: 'cubic-bezier(0.34, 1.56, 0.64, 1)',
} as const;

export const motion = {
  duration: durations,
  easing: easings,
} as const;

export type MotionDurationKey = keyof typeof durations;
export type MotionEasingKey = keyof typeof easings;
